'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const ErrorIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="ErrorIcon">
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_34_742)">
          <rect width="22" height="22" fill="white" />
          <path
            d="M0.458313 11C0.458313 12.3844 0.730981 13.7552 1.26075 15.0341C1.79052 16.3131 2.56701 17.4752 3.5459 18.4541C4.52478 19.433 5.68688 20.2095 6.96586 20.7392C8.24483 21.269 9.61563 21.5417 11 21.5417C12.3843 21.5417 13.7551 21.269 15.0341 20.7392C16.3131 20.2095 17.4752 19.433 18.4541 18.4541C19.4329 17.4752 20.2094 16.3131 20.7392 15.0341C21.269 13.7552 21.5416 12.3844 21.5416 11C21.5416 9.61565 21.269 8.24486 20.7392 6.96588C20.2094 5.68691 19.4329 4.5248 18.4541 3.54592C17.4752 2.56703 16.3131 1.79054 15.0341 1.26077C13.7551 0.731004 12.3843 0.458336 11 0.458336C9.61563 0.458336 8.24483 0.731004 6.96586 1.26077C5.68688 1.79054 4.52478 2.56703 3.5459 3.54592C2.56701 4.5248 1.79052 5.68691 1.26075 6.96588C0.730981 8.24486 0.458313 9.61565 0.458313 11Z"
            stroke="#C33241"
            strokeWidth="0.916667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.41669 6.41667L15.5834 15.5833"
            stroke="#C33241"
            strokeWidth="0.916667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.5834 6.41667L6.41669 15.5833"
            stroke="#C33241"
            strokeWidth="0.916667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </SvgIcon>
  )
}

ErrorIcon.propTypes = {
  sx: PropTypes.object
}
